module.exports = __webpack_public_path__ + "static/img/img2.d3ea856c.png";